import { render, staticRenderFns } from "./NsTable.vue?vue&type=template&id=7f592d77&"
import script from "./NsTable.vue?vue&type=script&lang=js&"
export * from "./NsTable.vue?vue&type=script&lang=js&"
import style0 from "./NsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VDataTable,VPagination,VProgressLinear})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f592d77')) {
      api.createRecord('7f592d77', component.options)
    } else {
      api.reload('7f592d77', component.options)
    }
    module.hot.accept("./NsTable.vue?vue&type=template&id=7f592d77&", function () {
      api.rerender('7f592d77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsTable.vue"
export default component.exports